/**
 * Admin preview of uploaded HTML, matching the teacher viewer (ryd-teacher-v2-vercel
 * src/pages/resources/htmlViewer.ts): same sandbox, and in-memory storage when the sandbox
 * blocks localStorage/sessionStorage, so interactive pages behave the same as for teachers.
 */
export const HTML_SANDBOX = "allow-scripts allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox";

const STORAGE_SCRIPT = `<script data-ryd-viewer>(function () {
  function memoryStorage() {
    var data = {};
    return {
      get length() { return Object.keys(data).length; },
      key: function (i) { return Object.keys(data)[i] || null; },
      getItem: function (k) { k = String(k); return Object.prototype.hasOwnProperty.call(data, k) ? data[k] : null; },
      setItem: function (k, v) { data[String(k)] = String(v); },
      removeItem: function (k) { delete data[String(k)]; },
      clear: function () { data = {}; }
    };
  }
  ["localStorage", "sessionStorage"].forEach(function (name) {
    try { window[name].getItem("__ryd"); } catch (e) {
      try { Object.defineProperty(window, name, { value: memoryStorage(), configurable: true }); } catch (e2) {}
    }
  });
})();</script>`;

/** Adds the storage script before the page's own scripts, without breaking its <!doctype>. */
export function prepareHtmlForPreview(html) {
  const source = String(html ?? "");
  const insertAfter = (match) =>
    match && match.index !== undefined
      ? source.slice(0, match.index + match[0].length) + STORAGE_SCRIPT + source.slice(match.index + match[0].length)
      : null;
  return (
    insertAfter(source.match(/<head(\s[^>]*)?>/i)) ??
    insertAfter(source.match(/<html(\s[^>]*)?>/i)) ??
    insertAfter(source.match(/^\s*<!doctype[^>]*>/i)) ??
    STORAGE_SCRIPT + source
  );
}
